import Marquee from "@/components/Marquee";
import Hero from "@/sections/Hero";
import Problem from "@/sections/Problem";
import Method from "@/sections/Method";
import Areas from "@/sections/Areas";
import Experiential from "@/sections/Experiential";
import Cases from "@/sections/Cases";
import Freedom from "@/sections/Freedom";
import Training from "@/sections/Training";
import Books from "@/sections/Books";
import DeltaSection from "@/sections/DeltaSection";
import AboutTeaser from "@/sections/AboutTeaser";
import Ecosystem from "@/sections/Ecosystem";
import FinalCTA from "@/sections/FinalCTA";

const HomePage = () => (
  <>
    <Hero />
    <Marquee items={["Persone", "Strategia", "Organizzazione", "Crescita", "Risultati"]} />
    <Problem />
    <Method />
    <Areas />
    <Experiential />
    <Cases />
    <Freedom />
    <Training />
    <Books />
    <DeltaSection />
    <AboutTeaser />
    <Ecosystem />
    <FinalCTA />
  </>
);

export default HomePage;
